// src/pages/AboutVVCMS.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./AboutVVCMS.css";
import aboutImg from "../assets/home-students.jpeg";

const AboutVVCMS = () => {
  const navigate = useNavigate();

  const handleKnowMore = () => {
    navigate("/inside-vvcms");
  };

  return (
    <section className="about-section" data-aos="fade-up">
      <div className="about-inner">
        {/* LEFT: IMAGE */}
        <div className="about-image-wrapper">
          <img
            src={aboutImg}
            alt="Vivek Vardhini Creative Minds School campus"
            className="about-image"
          />
        </div>

        {/* RIGHT: TEXT + BUTTON */}
        <div className="about-content">
          <h2 className="about-title">About VVCMS</h2>

          <p className="about-text">
            Vivek Vardhini Creative Minds School blends a century-old legacy of
            education with a modern CBSE framework. We nurture curious,
            confident and value-rooted learners in a safe, vibrant and engaging
            campus.
          </p>

          <p className="about-text">
            From classrooms and co-curriculars to character-building, every
            experience at VVCMS is designed to help children discover their
            strengths and shine as responsible global citizens.
          </p>

          <button className="about-btn" onClick={handleKnowMore}>
            Know More
          </button>
        </div>
      </div>
    </section>
  );
};

export default AboutVVCMS;
